module.exports = __webpack_public_path__ + "img/thumbnail.bfc0dfbb.png";